<template>
    <div class="info-item-area">
        <div
            v-if="!isFirst"
            class="info-item-split-line"/>
        <div class="info-item">
            <div class="title">
                {{ title }}
            </div>
            <div class="time">
                {{ value }}
            </div>
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';

 export default {
     name: 'InfoItem',
     props: {
         title: "",
         value: "",
         isFirst: false
     },
     computed: {
     },
     components: {
     },
     methods: {
     }
 }
</script>

<style scoped>
 .info-item-area {
     display: flex;
     flex-direction: row;
     align-items: center;

     margin-left: 20px;
     margin-right: 20px;
 }

 .info-item-split-line {
     background-color: #333;
     width: 1px;
     height: 26px;
     margin-right: 10px;
 }

 .title {
     font-size: 12px;
     color: #AAA;
 }

 .time {
     font-size: 24px;
     color: #FFF;
 }
</style>
